// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1geI2","list":"styles_list__2juPd"};